function countDecimalPlaces(value) {
  if (isNaN(value)) {
    return 0;
  }

  let decimalPos = String(value).indexOf('.');
  if(decimalPos === -1) {
    return 0;
  } else {
    return String(value).length - decimalPos -1;
  }
}

// TODO: Create a more flexible directive
function InputLlimitDirective() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, elem, attrs, ngModel) {
      let limit = parseInt(attrs.limit);
      let precision = parseInt(attrs.precision);

      if (isNaN(precision)) {
        // defaults to four decimal places 
        precision = 4;
      }


      angular.element(elem).on('keypress', function(e) {
        if (this.value.length === limit) {
          e.preventDefault();
        }

        if (e.which < 48 || e.which > 57) {
          if (e.which !== 46) {
            e.preventDefault();
          }
        }
      });

      // Validate input decimal places based on precision
      ngModel.$parsers.push((value) => {
          let places = countDecimalPlaces(value); 
          
          if (places > precision) {
            let prevValue = ngModel.$modelValue;
            ngModel.$setViewValue(prevValue);
            ngModel.$render();

            return prevValue;
          }

          return value;
      });
    }
  };
}

export default InputLlimitDirective;



// WEBPACK FOOTER //
// ./client/app/shared/directives/input-limit.directive.js